import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LeaderboardCalendarShowPage } from 'src/pages/LeaderboardsPage/LeaderboardCalendarShowPage';
import { LeaderboardCalendarsPage } from 'src/pages/LeaderboardsPage/LeaderboardCalendarsPage';
import { LeaderboardDivisionPage } from 'src/pages/LeaderboardsPage/LeaderboardDivisionPage';
import { LeaderboardFormPage } from 'src/pages/LeaderboardsPage/LeaderboardFormPage';
import { LeaderboardShowPage } from 'src/pages/LeaderboardsPage/LeaderboardShowPage';
import { LeaderboardWorkoutDivisionPage } from 'src/pages/LeaderboardsPage/LeaderboardWorkoutDivisionPage';
import { LeaderboardWorkoutPage } from 'src/pages/LeaderboardsPage/LeaderboardWorkoutPage';
import { LeaderboardsPage } from 'src/pages/LeaderboardsPage/LeaderboardsPage';
import { PublicLeaderboardsPage } from 'src/pages/LeaderboardsPage/PublicLeaderboardsPage';

/**
 * Routes for the Leaderboards section
 * These routes are accessible under /leaderboards/
 */
const LeaderboardsRoutes: FC = () => {
  return (
    <Routes>
      {/* Admin */}
      <Route index element={<LeaderboardsPage />} />
      <Route path="new" element={<LeaderboardFormPage />} />
      <Route path=":id/edit" element={<LeaderboardFormPage />} />

      {/* Public */}
      <Route path="public" element={<PublicLeaderboardsPage />} />
      <Route path="public/calendars" element={<LeaderboardCalendarsPage />} />
      <Route
        path="public/calendars/:calendarId"
        element={<LeaderboardCalendarShowPage />}
      />
      <Route
        path="public/workout/:workoutId"
        element={<LeaderboardWorkoutPage />}
      />
      <Route
        path="public/workout/:workoutId/:type/:division"
        element={<LeaderboardWorkoutDivisionPage />}
      />
      <Route
        path="public/workout/:workoutId/:type/:division/:subdivision"
        element={<LeaderboardWorkoutDivisionPage />}
      />
      <Route path="public/:id" element={<LeaderboardShowPage />} />
      <Route
        path="public/:id/:type/:division"
        element={<LeaderboardDivisionPage />}
      />
    </Routes>
  );
};

export default LeaderboardsRoutes;
